import store from "../store";
import { changePassword } from "./restFunctions";

export default async (values, source) => {
  const {
    customerDetails: { username },
    authenticationToken: { token },
    forms: { changePasswordForm }
  } = store;
  if (token && username) {
    store.setUI("formSubmitting", true);
    const { currentPassword, newPassword } = values;

    await changePassword(username, currentPassword, newPassword, token, source)
      .then(response => {
        const { isOK } = response;
        if (isOK) {
          changePasswordForm.clear();
          return store.setUI("snackbar", {
            visible: true,
            severity: "success",
            content: "Your password has been changed successfully. "
          });
        }
        store.setUI("formSubmitting", false);
        return store.setUI("snackbar", {
          visible: true,
          severity: "warning",
          content: "Your password could not be changed, please try again. "
        });
      })
      .catch(error => {
        store.setUI("formSubmitting", false);
      })
      .finally(() => store.setUI("formSubmitting", false));
  }
};
